import { render, staticRenderFns } from "./distributionGoods.vue?vue&type=template&id=38648833&scoped=true&"
import script from "./distributionGoods.vue?vue&type=script&lang=js&"
export * from "./distributionGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38648833",
  null
  
)

export default component.exports